import { onPendingNavigation, onPreviewOperationStart } from '../actions/publicLazyActions';
import sxsStore from '../store/Store';
import { mutator } from 'satcheljs';

mutator(onPendingNavigation, actionMessage => {
    const { attachmentId } = actionMessage;
    sxsStore.pendingNavigation = !attachmentId
        ? null
        : {
              toAttachmentId: {
                  Id: attachmentId,
                  mailboxInfo: null,
              },
              triggerTime: new Date().getTime(),
          };
});

mutator(onPreviewOperationStart, () => {
    sxsStore.pendingNavigation = null;
});
